import React, { useState } from "react";
import { Form, Input, Button, message, Upload, Row, Col } from "antd";
import axios from "axios";
import { API_URL } from "../../config";
import { useTranslation } from "react-i18next";

const EditDoctorProfile = ({ doctorDetails, onClose, onProfileUpdate }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [uploading, setUploading] = useState(false);
  const apiEndpoint = `${API_URL}/doctor/${doctorDetails?.doctor_id}`;

  const requiredMessage = (key) => ({
    required: true,
    message: `${t("validation.pleaseEnter")} ${t(key).toLowerCase()}!`,
  });

  const handleFinish = async (values) => {
    try {
     const response = await axios.put(
        apiEndpoint,
        {
          ...values,
          firebase_id: doctorDetails?.firebase_id,
          doctor_id: doctorDetails?.doctor_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        message.success(t("message.doctorUpdatedSuccessfully"));
        onProfileUpdate(response.data);
        onClose();
      } else {
        message.error(t("message.failedDoctorSave"));
      }
    } catch (error) {
      console.error("Error updating doctor profile:", error);
      message.error(t("message.failedDoctorSave"));
    }
  };

  const handleUpload = async ({ file }) => {
    const formData = new FormData();
    formData.append("firebase_id", doctorDetails?.firebase_id);
    formData.append("file", file);

    setUploading(true);

    try {
      const response = await axios.post(
        `${API_URL}/user/upload-profile-picture`,
        formData,
         {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
   if (response.status === 200) {
        message.success(t("message.doctorUpdatedSuccessfully"))
      } else {
        message.error(t("message.failedDoctorSave"));
      }
    } catch (error) {
      console.error("Error uploading profile picture:", error);
      message.error(t("message.failedDoctorSave"));
    } finally {
      setUploading(false);
    }
  };

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{
        salutation: doctorDetails?.salutation,
        first_name: doctorDetails?.first_name,
        last_name: doctorDetails?.last_name,
        phone_number: doctorDetails?.phone_number,
        email_address: doctorDetails?.email_address,
        date_of_birth: doctorDetails?.date_of_birth,
        gender: doctorDetails?.gender,
        clinic: doctorDetails?.clinic,
        professional_profile: doctorDetails?.professional_profile,
        medical_registration: doctorDetails?.medical_registration,
        specialties: doctorDetails?.specialties,
        qualifications: doctorDetails?.qualifications,
      }}
     onFinish={handleFinish}
    >
      <Row gutter={16}>
        <Col span={8}>
        {" "}
          <Form.Item
            name="salutation"
            label={t("doctor.salutation")}
            rules={[requiredMessage("doctor.salutation")]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name="first_name"
            label={t("doctor.firstName")}
            rules={[requiredMessage("doctor.firstName")]}
          >
            <Input />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name="last_name"
            label={t("doctor.lastName")}
            rules={[requiredMessage("doctor.lastName")]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={10}>
          <Form.Item
            name="phone_number"
            label={t("doctor.phoneNumber")}
            rules={[requiredMessage("doctor.phoneNumber")]}
          >
            <Input />
          </Form.Item>
        </Col>
         <Col span={2}></Col>
        <Col span={12}>
          {" "}
          <Form.Item
            name="email_address"
            label={t("doctor.emailAddress")}
            rules={[requiredMessage("doctor.emailAddress")]}
          >
            <Input
             disabled 
            style={{
                backgroundColor: "#e8e8e8",
                color: "black",
                cursor: "not-allowed",
              }}/>
          </Form.Item>
        </Col>{" "}
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          {" "}
          <Form.Item
            name="gender"
            label={t("doctor.gender")}
            rules={[requiredMessage("doctor.gender")]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name="date_of_birth"
            label={t("doctor.dateOfBirth")}
            rules={[requiredMessage("doctor.dateOfBirth")]}
          >
            <Input type="date" />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name="clinic"
            label={t("doctor.clinic")}
            rules={[requiredMessage("doctor.clinic")]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={10}>
           {" "}
          <Form.Item
            name="professional_profile"
            label={t("doctor.professionalProfile")}
          >
            <Input.TextArea />
          </Form.Item>{" "}
        </Col>
       <Col span={2}></Col>
        <Col span={12}>
           {" "}
          <Form.Item
            name="medical_registration"
            label={t("doctor.medicalRegistration")}
          >
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={10}>
          {" "}
          <Form.Item
            name="specialties"
            label={t("doctor.specialties")}
          >
            <Input.TextArea />
          </Form.Item>
        </Col>

         <Col span={2}></Col>
        <Col span={12}>
          {" "}
          <Form.Item
            name="qualifications"
            label={t("doctor.qualifications")}
          >
            <Input.TextArea />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={10}>
          <Form.Item
            label={t("doctor.uploadProfilePicture")}
            extra={t("doctor.uploadHint")}
          >
            <Upload
              showUploadList={false}
              customRequest={handleUpload}
              accept=".png, .jpg, .jpeg"
            >
              <Button loading={uploading}>
                {uploading
                  ? t("doctor.uploading")
                  : t("doctor.uploadButton")}
              </Button>
            </Upload>
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Row justify="end" gutter={8}>
          <Col span={20}></Col>
          
          <Col>
            <Button type="default" danger onClick={onClose}>
              {t("common.cancel")}
            </Button>
          </Col>
          <Col>
            <Button type="primary" htmlType="submit">
              {t("common.save")}
            </Button>
          </Col>
        </Row>
      </Form.Item>
    </Form>
  );
};

export default EditDoctorProfile;
